/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import sanitizeHtml from 'sanitize-html';
import { Flex } from '@getgo/chameleon-chakra-ui';

export interface Props {
  impressionTrackers: string[];
}

export const WFATrackers: React.FC<Props> = (props) => {
  const { impressionTrackers } = props;
  return (
    <Flex>
      {impressionTrackers.map((tracker: string, index: number) => {
        return (
          <Flex h='0' overflow='hidden' key={index}>
            <img src={sanitizeHtml(tracker)} alt='Advertisement' />
          </Flex>
        );
      })}
    </Flex>
  );
};
